import { useCallback, useEffect, useState } from "react";
import { listCatalog } from "@/api/shopCatalog";
import type { CatalogRecord } from "@/types/shopCatalog";

export function useSpecifications(enabled: boolean): {
  specs: CatalogRecord[]; values: CatalogRecord[]; loading: boolean; failed: boolean; refresh: () => void;
} {
  const [specs, setSpecs] = useState<CatalogRecord[]>([]);
  const [values, setValues] = useState<CatalogRecord[]>([]);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);
  const [revision, setRevision] = useState(0);
  const refresh = useCallback((): void => setRevision((current) => current + 1), []);
  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    setLoading(true); setFailed(false);
    void Promise.all([listCatalog("spec", undefined, controller.signal), listCatalog("specValue", undefined, controller.signal)])
      .then(([specResult, valueResult]) => {
        if (!controller.signal.aborted) { setSpecs(specResult.data ?? []); setValues(valueResult.data ?? []); }
      })
      .catch(() => { if (!controller.signal.aborted) setFailed(true); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return (): void => controller.abort();
  }, [enabled, revision]);
  return { specs, values, loading, failed, refresh };
}
